import get from "lodash/get";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import { CommonReducerAction, setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import FloatValues from "../../../../../../../Component/FloatValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leavename: "",
  leaveid: null,
  earnedleave: 1,
  completionday: 1,
  credittypeid: 2,
  ispresentday: false,
  isleave: false,
  isabsentday: false,
  isweekoff: false,
  isholiday: false,
};
class NameLeaveAllocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language ? this.props.Language.extratimepolicy[key] : "",
    });
  };

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => this.SetValues(props));
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const InitLeavesPolicy = props.InitLeavesPolicy.policy[ParentIndex];
      this.setState({
        leavename: InitLeavesPolicy.leavename,
        ParentIndex,
        leavetypeid: props.leavetypeid,
        earnedleave: InitLeavesPolicy.earnedleave,
        completionday: InitLeavesPolicy.completionday,
        credittypeid: InitLeavesPolicy.credittypeid,
        ispresentday: InitLeavesPolicy.ispresentday,
        isleave: InitLeavesPolicy.isleave,
        isabsentday: InitLeavesPolicy.isabsentday,
        isweekoff: InitLeavesPolicy.isweekoff,
        isholiday: InitLeavesPolicy.isholiday,
      });
    } else {
      const parentIndex = props.ParentIndex || 0;
      const name = get(props, `InitLeavesPolicy.details[${parentIndex}]`, "");
      this.setState({ ...ParentState, leavename: name && get(name, "leavetypename", "") });
    }
  }

  handleChange(name, ...arg) {
    switch (name) {
      case "credittypeid":
        this.setState(
          {
            [name]: arg[0],
            ispresentday: false,
            isleave: false,
            isabsentday: false,
            isweekoff: false,
            isholiday: false,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "ispresentday":
      case "isleave":
      case "isabsentday":
      case "isweekoff":
      case "isholiday":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find((x) => x.leavetypeid == this.state.leavetypeid);
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      leavename: this.state.leavename,
      earnedleave: this.state.earnedleave,
      completionday: this.state.completionday,
      credittypeid: this.state.credittypeid,
      ispresentday: this.state.ispresentday,
      isleave: this.state.isleave,
      isabsentday: this.state.isabsentday,
      isweekoff: this.state.isweekoff,
      isholiday: this.state.isholiday,
    };
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, InitLeavesPolicy);
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value) {
      let value;
      if (Number(event.target.value) > Number(max) || Number.isNaN(event.target.value)) value = this.state[name];
      else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  checkUnique() {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    const { ParentIndex, leavename } = this.state;
    if (leavename || leavename != "") {
      if (
        leavename.includes("employeename")
        || leavename.includes("employeecode")
        || leavename.includes("designation")
        || leavename.includes("department")
        || leavename.includes("businessunit")
      ) {
        enqueueSnackbar("Please enter valid leave name", {
          variant: "error",
        });
        this.setState({ notUnique: true }, () => {
          if (this.props.InitLeavesPolicy.policy[ParentIndex] && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid) {
            this.UpdateReducer();
          }
        });
      } else if (
        this.props.InitLeavesPolicy.policy[ParentIndex]
            && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid
      ) {
        this.UpdateReducer();
      } else {
        instance
          .post("/leaves/uniqueleavename", {
            leavename,
            leavetypeid: InitLeavesPolicy.details[ParentIndex].leavetypeid,
            leavecategoryid: InitLeavesPolicy.details[ParentIndex].leavecategoryid,
            leaveid: this.props.InitLeavesPolicy.policy[ParentIndex] ? this.props.InitLeavesPolicy.policy[ParentIndex].leaveid : null,
          })
          .then(() => {
            this.setState({ notUnique: false }, () => this.UpdateReducer());
          })
          .catch((error) => {
            this.setState({ notUnique: true });
            enqueueSnackbar(error.response ? error.response.data.error.message : error.message, {
              variant: "error",
            });
          });
      }
    } else {
      this.setState({ notUnique: true }, () => {
        if (this.props.InitLeavesPolicy.policy[ParentIndex] && this.props.InitLeavesPolicy.policy[ParentIndex].leaveid) {
          this.UpdateReducer();
        }
      });
    }
  }

  onNameChange(event) {
    this.setState({ leavename: event.target.value });
    if (this.props.ChangeSteppername) this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
  }

  validateNext() {
    this.checkUnique();
    if (!this.state.leavename || this.state.leavename == "") {
      this.setState({ notUnique: true });
    } else {
      this.props.click();
    }
  }

  render() {
    const language = this.props.Language.extratimepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div>
          {/* <p class="input-form-label">
                    </p> */}
          <div className="inner-wrapper opaque">
            <div className="form-group">
              <p className="form-main-header">
                <FormattedMessage id="LbleaveName" defaultMessage="Let’s give this leave a name" />
              </p>
              <div>
                <input
                  type="text"
                  className="form-control"
                  autoComplete="off"
                  maxLength={50}
                  // autoFocus
                  placeholder="Leave Name"
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.leavename}
                  onBlur={this.checkUnique.bind(this)}
                />
                <br />
                {this.state.notUnique ? <span className="caption-error leave-policy-error">This doesn&apos;t look like a valid leave name</span> : null}
              </div>
            </div>
          </div>
          {/* 1 */}
          <div>
            <p className="form-main-header">
              <FormattedMessage id="LbLeaveAllocation" defaultMessage="Leave Allocation" />
            </p>
            <div className="inner-wrapper opaque">
              <p className="form-sub-header">
                <FormattedMessage id="LbEarnLeaveBalance" defaultMessage="How can employees earn their leave balance?" />
              </p>
              <p className="depedent-select-list-head">
                <FormattedMessage id="LbEarnLeaveBalanceInOneManner" defaultMessage="Employees can earn leave balance in one of the following manner:" />
              </p>
              <div>
                <FloatValues
                  min="1"
                  max="365"
                  step="0.25"
                  field="earnedleave"
                  onChange={this.CommonNumberChange.bind(this, "earnedleave", 365)}
                  value={this.state.earnedleave}
                  defaultvalue={this.state.earnedleave}
                />

                <FormattedMessage id="LbEarnLeaveCreditedOnCompletion" defaultMessage="leaves must be credited on completion of " />
                <InputValues
                  min="1"
                  max="1825"
                  field="completionday"
                  onChange={this.CommonNumberChange.bind(this, "completionday", 1825)}
                  value={this.state.completionday}
                  defaultvalue={this.state.completionday}
                />

                <FormattedMessage id="LbDays" defaultMessage="days" />
              </div>
            </div>
            <div className="inner-wrapper margin-top-20 opaque">
              <p className="depedent-select-list-head">
                <FormattedMessage id="LbTheseDaysInclude" defaultMessage="These days include:" />
              </p>
              <div className="depedent-select-list" onClick={() => this.handleChange("credittypeid", 1)} aria-expanded={this.state.credittypeid == 1}>
                <span>
                  <FormattedMessage id="LbSpecificDays" defaultMessage="Specific days" />
                </span>
                {this.state.credittypeid == 1 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse in={this.state.credittypeid == 1} timeout={2} unmountOnExit className="padding30 overflow-initial">
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("ispresentday", !this.state.ispresentday)}
                    aria-expanded={this.state.ispresentday}
                  >
                    <span>
                      <FormattedMessage id="LbPresentDays" defaultMessage="Present days only" />
                    </span>
                    {this.state.ispresentday ? (
                      <span className="floatright selected-box">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box" />
                    )}
                  </div>
                  <div className="depedent-select-list" onClick={() => this.handleChange("isleave", !this.state.isleave)} aria-expanded={this.state.isleave}>
                    <span>
                      <FormattedMessage id="LbLeaves" defaultMessage="Leaves" />
                    </span>
                    {this.state.isleave ? (
                      <span className="floatright selected-box">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("isabsentday", !this.state.isabsentday)}
                    aria-expanded={this.state.isabsentday}
                  >
                    <span>
                      <FormattedMessage id="LbAbsentDays" defaultMessage="Absent days" />
                    </span>
                    {this.state.isabsentday ? (
                      <span className="floatright selected-box">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("isweekoff", !this.state.isweekoff)}
                    aria-expanded={this.state.isweekoff}
                  >
                    <span>
                      <FormattedMessage id="LbWeeklyOff" defaultMessage="Weekly-offs" />
                    </span>
                    {this.state.isweekoff ? (
                      <span className="floatright selected-box">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("isholiday", !this.state.isholiday)}
                    aria-expanded={this.state.isholiday}
                  >
                    <span>
                      <FormattedMessage id="LbMandatoryOptionalHoliday" defaultMessage="Mandatory & Optional Holidays taken" />
                    </span>
                    {this.state.isholiday ? (
                      <span className="floatright selected-box">
                        <svg width="24" height="24" viewBox="0 0 24 24">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </span>
                    ) : (
                      <span className="not-selected-box" />
                    )}
                  </div>
                </Collapse>
              </div>
              <div className="depedent-select-list" onClick={() => this.handleChange("credittypeid", 2)} aria-expanded={this.state.credittypeid == 2}>
                <span>
                  <FormattedMessage id="LbAllDays" defaultMessage="All days" />
                </span>
                {this.state.credittypeid == 2 ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
            </div>
          </div>
          {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
                        Next
                    </Button> */}
        </div>
      </IntlProvider>
    );
  }
}
NameLeaveAllocation.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(NameLeaveAllocation)));
